import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ 'label', 'input' ]

  connect() {
    const initial = parseInt(this.data.get('spent') || '0') * 1000

    if (this.data.get('started') === null) {
      this.data.set('started', new Date().getTime())
    }
    const started = parseInt(this.data.get('started'))


    // 345021 becomes 05:45
    function formatMilliseconds(ms) {
      const seconds = Math.floor(ms/1000)
      const m = Math.floor(seconds/60)
      const s = seconds % 60
      return (m < 10 ? '0' + m : m) + ':' + (s < 10 ? '0' + s : s)
    }

    const label = this.labelTarget
    const input = this.inputTarget

    const updateTimeSpent = function() {
      const elapsed = (new Date().getTime()) - started
      const ms = initial + elapsed
      label.innerText = formatMilliseconds(ms)
      input.value = Math.floor(elapsed/1000)
    }

    this.interval = setInterval(updateTimeSpent, 330);
  }


}
